import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { PageModel } from 'client/data/models/page';
import { EV_RANGE_LEADERBOARD_CONTENT_PATH } from 'site-modules/editorial/constants/ev-range-charts';
import { LeaderboardInfographic } from 'site-modules/editorial/components/leaderboard-infographic/leaderboard-infographic';

import './ev-range-leaderboard.scss';

function EvRangeLeaderBoardUI({ content = null, pathname = null, isWidget = false }) {
  if (!content) {
    return null;
  }

  return (
    <LeaderboardInfographic
      className="ev-range-leaderboard"
      titleColorClassName="text-white"
      content={content}
      pathname={pathname}
      widgetName="ev-range-leaderboard"
      title="EV Range Leaderboard"
      barsMap={[
        { label: 'EPA estimate', key: 'estimate' },
        { label: 'Edmunds tested', key: 'tested' },
      ]}
      stepValue={100}
      chartValueMeasure="mi"
      isWidget={isWidget}
    />
  );
}

EvRangeLeaderBoardUI.propTypes = {
  content: CmsEntities.Content,
  pathname: PropTypes.string,
  isWidget: PropTypes.bool,
};

export const EvRangeLeaderBoard = connectToModel(EvRangeLeaderBoardUI, {
  content: bindToContent(EV_RANGE_LEADERBOARD_CONTENT_PATH),
  pathname: bindToPath('location.pathname', PageModel),
});
